export const regexPasswordRules = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ !\"!#$%&'()*+,-./:;<=>?@[\\]^_`{|}~])"

export const regexSnakeCase = '^[a-z_]$'

export const regexURL = '^https?://(www.)?[-a-zA-Z0-9@:%._+~#=]{1,256}.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$'
